import { IconButton } from '@mui/material';
import { Stack } from '@mui/system';
import Overlay from './customOverlay';

export default function NoRowsOverlayWithAdd(props) {
  return (
    <Stack direction="column" justifyContent="stretch" alignItems="stretch">
      <IconButton
        id="norows-add-button"
        onClick={props?.onClick}
        sx={{
          zIndex: 1,
          borderRadius: 1,
        }}
      >
        <Stack direction="column" justifyContent="center" alignItems="center">
          <Overlay title="Brak pozycji - kliknij, aby dodać" />
        </Stack>
      </IconButton>
    </Stack>
  );
}
